import { useRealtimeConversationLogs } from './useRealtimeConversationLogs';

export const useAdminWebSocketConversation = (
  conversationId: string,
  onError?: <T>(error: T) => void,
) => useRealtimeConversationLogs('adminConversationLogsPaginated', conversationId, onError);
